import { defineComponent as _defineComponent } from 'vue'
import { formatPrice } from "@/helpers/transformation/price";
  import { computed } from "vue";
  import { calculateBuildPriceOrPackagePriceTotal } from "@/helpers/builder/calculateBuildPriceOrPackagePriceTotal";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryPackage',
  props: {
    project: {
      type: String,
      default: () => "",
    },
    lot: {
      type: String,
      default: () => "",
    },
    landSize: {
      type: Number,
      default: () => 0,
    },
    landPrice: {
      type: Number,
      default: () => 0,
    },
    homeArea: {
      type: Number,
      default: () => 0,
    },
    homePrice: {
      type: Number,
      default: () => 0,
    },
    facadePrice: {
      type: Number,
      default: () => 0,
    },
    siteCosts: {
      type: Number,
      default: () => 0,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get formatPrice() { return formatPrice }, computed, get calculateBuildPriceOrPackagePriceTotal() { return calculateBuildPriceOrPackagePriceTotal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})